import React, { Component } from 'react';
import Logoimg from '../../assets/images/MLL_logo_nettisivuille.png';

class Logo extends Component {
  componentDidMount() {}

  paivita = () => {
    window.location.reload();
  };

  render() {
    return (
      <div className={'Logo'}>
        <img
          src={Logoimg}
          height='80'
          alt='logo'
          onClick={() => this.paivita()}
        />
      </div>
    );
  }
}
export default Logo;
